import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function StoreSwitcher() {
  const [stores, setStores] = useState([]);
  const [current, setCurrent] = useState(localStorage.getItem("pdv_store") || "");
  useEffect(() => {
    api.get("/stores").then((r) => {
      const active = r.data.filter((s) => s.active);
      setStores(active);
      if (!active.some((s) => s.id === current)) {
        localStorage.removeItem("pdv_store");
        setCurrent(active[0]?.id || "");
      }
    }).catch(() => {});
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  if (stores.length < 2) return null;
  const change = (id) => {
    localStorage.setItem("pdv_store", id);
    setCurrent(id);
    toast.success(`Unidade: ${stores.find((s) => s.id === id)?.name}`);
  };
  return (
    <div className="mt-4">
      <p className="eyebrow mb-1.5 flex items-center gap-1"><Building2 className="h-3 w-3" />Unidade atual</p>
      <Select value={current} onValueChange={change}>
        <SelectTrigger className="h-9" data-testid="store-switcher"><SelectValue /></SelectTrigger>
        <SelectContent>{stores.map((s) => <SelectItem key={s.id} value={s.id}>{s.name}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
